import React from 'react';
import './Footer.css';
import Footer_L from '../../Assets/Footer_L.jpg';
import Footer_D from '../../Assets/Footer_D.jpg';
import { useSelector } from 'react-redux';
import image from '../../Assets/new_image_logo.png';

const Footer = () => {
  const theme = useSelector((store) => store.ThemeSlice.theme);

  return (
    <footer className="footer">
      <img 
        src={theme === 'light-mode' ? Footer_L : Footer_D} 
        alt="Learning Illustration" 
        className="footer-image" 
      />
      <div className="footer-container">
        <div className="footer-logo">
          <img src={image} alt='Company Logo' className='image-logo' />
        </div>
        <div className="footer-links">
          <div className="footer-column">
            <a href="/">Home</a>
            <a href="/course-upload-guidelines">Course Upload Guidelines</a>
            <a href="/about">About Us</a>
            <a href="/support">Contact Us</a>
          </div>
          <div className="footer-column">
            <a href="/terms-conditions">Terms & Conditions</a>
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/sitemap">Site Map</a>
          </div>
           
        </div>
      </div>
    </footer>
  );
};

export default Footer;
